export default "__VITE_ASSET__C$$g2LTF__"